export default __webpack_public_path__ + "static/media/2.a41592f3.png";